import React from 'react';
import { experience } from '../data/mock';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { Briefcase, MapPin, Calendar } from 'lucide-react';

const Experience = () => {
  return (
    <section id="experience" className="py-20 px-6">
      <div className="container mx-auto max-w-4xl">
        <div className="space-y-4 mb-12">
          <h2 className="text-sm font-mono text-cyan-500 uppercase tracking-wider">
            Where I've worked
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold">Experience</h3>
        </div>

        <div className="space-y-8">
          {experience.map((job, index) => (
            <Card key={index} className="p-8 hover:border-cyan-500/50 transition-all">
              <div className="space-y-6">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                  <div className="space-y-2">
                    <h4 className="text-2xl font-bold">{job.company}</h4>
                    <p className="text-lg text-cyan-500">{job.role}</p>
                  </div>
                  <div className="flex flex-col gap-2 text-sm text-muted-foreground">
                    <div className="flex items-center gap-2">
                      <Calendar className="h-4 w-4" />
                      {job.period}
                    </div>
                    <div className="flex items-center gap-2">
                      <MapPin className="h-4 w-4" />
                      {job.location}
                    </div>
                  </div>
                </div>

                <p className="text-muted-foreground">{job.description}</p>

                <ul className="space-y-3">
                  {job.highlights.map((highlight, hIndex) => (
                    <li key={hIndex} className="flex gap-3">
                      <span className="text-cyan-500 mt-1.5 flex-shrink-0">•</span>
                      <span className="text-muted-foreground leading-relaxed">{highlight}</span>
                    </li>
                  ))}
                </ul>

                <div className="flex flex-wrap gap-2 pt-2">
                  {job.technologies.map((tech, tIndex) => (
                    <Badge key={tIndex} variant="outline" className="font-mono text-xs">
                      {tech}
                    </Badge>
                  ))}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
